import React, {PropsWithChildren} from "react";
import classNames from "classnames";
import {observer} from "mobx-react";
import styles from './Toast.styl';

export const enum ToastAlignment {
    BOTTOM = '__bottom'
}

interface ToastPropsBase {
    className?: string;
    alignment?: ToastAlignment;
    style?: React.CSSProperties
}

type ToastProps = PropsWithChildren<ToastPropsBase>;

export const Toast: React.FC<ToastProps> = observer(({children, className, alignment, style}) => {
    const toastClass = classNames(styles['toast'], alignment && styles[alignment], className);
    return (
        <div className={toastClass} style={style}>
            {children}
        </div>
    );
});
